import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getALLCategory, getAllProducts } from "../apis/config";
import ProductCard from "../components/ProductCard";
import ComingSoon from "./ComingSoon";

const SubCategoryPage = () => {
  const { category, subCategory } = useParams();
  const [categorys, setCategorys] = useState([]);
  const [products, setProducts] = useState([]);
  const [sel, setSel] = useState("All");
  const navigate = useNavigate();

  useEffect(() => {
    getALLCategory()
      .then((res) => setCategorys(res.data))
      .catch((err) => console.log(err));

    getAllProducts()
      .then((res) => setProducts(res.data))
      .catch((err) => console.log(err));
  }, []);

  const subCateId = categorys
    .find((cat) => cat.name === category)
    ?.subcategories.find((s) => s.name === subCategory)?._id;

  const subcat = categorys
    .find((cat) => cat.name === category)
    ?.subcategories.find((s) => s.name === subCategory)?.types;

  const filterProducts =
    sel === "All"
      ? products.filter((pro) => pro.subCategory === subCateId)
      : products.filter((pro) => pro.type === sel);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      {/* Breadcrumb */}
      <h6 className="text-gray-400 text-xs sm:text-sm mt-4 text-center flex flex-wrap justify-center gap-1 capitalize">
        <span
          className="hover:text-black cursor-pointer"
          onClick={() => navigate("/")}
        >
          Home
        </span>
        <span>{">"}</span>
        <span
          className="hover:text-black cursor-pointer"
          onClick={() => navigate(`/category/${category}`)}
        >
          {category}
        </span>
        <span>{">"}</span>
        <span className="text-gray-700 hover:text-black cursor-pointer">
          {subCategory}
        </span>
      </h6>

      {/* Title */}
      <h3 className="text-primary font-semibold capitalize pt-5 text-center text-lg sm:text-xl">
        {subCategory}
      </h3>

      {/* Filter types */}
      {subcat?.length > 0 && (
        <div className="flex overflow-x-auto gap-3 py-5 justify-start sm:justify-center items-center scrollbar-hide">
          {/* "All" filter */}
          <div
            className={`w-28 h-32 sm:w-32 sm:h-40 bg-gray-100 flex flex-col justify-center items-center p-2 gap-2 cursor-pointer border-2 ${
              sel === "All"
                ? "border-primary text-primary"
                : "hover:border-primary hover:text-primary"
            }`}
            onClick={() => setSel("All")}
          >
            <div className="w-20 h-20">
              <img
                src="/assets/all.webp"
                alt="All"
                className="w-full h-full object-cover rounded"
              />
            </div>
            <h4 className="text-xs font-medium text-center capitalize truncate w-full">
              All
            </h4>
          </div>

          {/* Dynamic filters */}
          {subcat.map((sub, index) => (
            <div
              key={index}
              className={`w-28 h-32 sm:w-32 sm:h-40 bg-gray-100 flex flex-col justify-center items-center p-2 gap-2 cursor-pointer border-2 ${
                sel === sub._id
                  ? "border-primary text-primary"
                  : "hover:border-primary hover:text-primary"
              }`}
              onClick={() => setSel(sub._id)}
            >
              <div className="w-20 h-20">
                <img
                  src={sub.image}
                  alt={sub.name}
                  className="w-full h-full object-contain rounded"
                />
              </div>
              <h4 className="text-xs font-medium text-center capitalize truncate w-full">
                {sub.name}
              </h4>
            </div>
          ))}
        </div>
      )}

      {/* Products grid */}
      {filterProducts.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 py-5">
          {filterProducts.map((data, index) => (
            <ProductCard key={index} data={data} />
          ))}
        </div>
      ) : (
        <ComingSoon />
      )}
    </div>
  );
};

export default SubCategoryPage;
